export function loadData(key) {
  let data = {}
  if (window.localStorage) {
    try {
      data = JSON.parse(window.localStorage.getItem(key))
    } catch (e) {}
  }
  return data
}

export function saveData(key, data) {
  if (window.localStorage) {
    window.localStorage.setItem(key, JSON.stringify(data))
  }
}

export function toggleLocalStorageWatcher(callback, toggle = true) {
  const action = toggle ? 'addEventListener' : 'removeEventListener'
  window[action]('storage', callback)
}
